<template>
  <form id="form" action="/backend/submit_message.php" method="POST" @submit.prevent="onSubmit" novalidate
    class="mt-5 space-y-4">
    <input type="hidden" name="redirect" value="https://animauxdelasecondechance.com/confirmation-message">
    <div>
      <label class="block font-medium text-xs sm:text-sm md:text-base lg:text-lg text-gray-700">Nom complet <span
          class="text-red-500">*</span></label>
      <input v-model="form.nomComplet" type="text" name="nomComplet" placeholder="Inscrire votre nom"
        class="w-full mt-1 p-3 border rounded-md focus:ring-2 focus:primaire outline-none text-xs sm:text-sm md:text-base lg:text-lg" />
      <span v-if="erreurs.nomComplet" class="text-red-500 text-xs sm:text-sm md:text-base lg:text-lg mt-1">{{
        erreurs.nomComplet }}</span>
    </div>

    <div>
      <label class="block font-medium text-xs sm:text-sm md:text-base lg:text-lg text-gray-700">email <span
          class="text-red-500">*</span></label>
      <input v-model="form.email" type="email" name="email" placeholder="Inscrire votre courriel"
        class="w-full mt-1 p-3 border rounded-md focus:ring-2 focus:primaire outline-none text-xs sm:text-sm" />
      <span v-if="erreurs.email" class="text-red-500 text-xs sm:text-sm md:text-base lg:text-lg mt-1">{{ erreurs.email
        }}</span>
    </div>

    <div>
      <label class="block font-medium text-xs sm:text-sm md:text-base lg:text-lg text-gray-700">Sujet <span
          class="text-red-500">*</span></label>
      <input v-model="form.sujet" type="text" name="sujet" placeholder="Sujet de votre message"
        class="w-full mt-1 p-3 border rounded-md focus:ring-2 focus:primaire outline-none text-xs sm:text-sm"
        aria-label="sujet" title="Sujet de votre message" />
      <span v-if="erreurs.sujet" class="text-red-500 text-xs sm:text-sm md:text-base lg:text-lg mt-1">{{ erreurs.sujet
        }}</span>
    </div>

    <div>
      <label class="block font-medium text-xs sm:text-sm md:text-base lg:text-lg text-gray-700">Votre message <span
          class="text-red-500">*</span></label>
      <textarea v-model="form.message" name="message" placeholder="Écrivez votre message !" rows="4"
        class="w-full mt-1 p-3 border rounded-md focus:ring-2 focus:primaire outline-none text-xs sm:text-sm"
        aria-label="message" title="Votre message"></textarea>
      <span v-if="erreurs.message" class="text-red-500 text-xs sm:text-sm md:text-base lg:text-lg mt-1">{{
        erreurs.message }}</span>
    </div>

    <div class="flex items-center justify-center w-full">
      <input id="submit-button"
        class="shadow-sm bg-action hover:bg-navigation text-white font-bold py-2 px-4 mt-6 rounded focus:outline-none focus:shadow-outline cursor-pointer text-xs sm:text-sm"
        type="submit" title="Envoyez" value="Envoyez  ➤"
        aria-label="Envoyer le message" tabindex="0">
      <input
        class="shadow bg-primaire hover:bg-navigation text-white font-bold py-2 px-4 mt-6 ml-6 rounded focus:outline-none focus:shadow-outline cursor-pointer text-xs sm:text-sm"
        type="reset" title="réinitialiser">
    </div>
  </form>

</template>

<script setup>
  import {ref} from 'vue';
  import {useRouter} from 'vue-router';
  import {validateFormMessage} from '../composables/validateFormMessage.js';
  import {useRecaptcha} from '../composables/useRecaptcha.js';

  const router = useRouter();

  const form = ref({
    nomComplet: '',
    email: '',
    sujet: '',
    message: '',
});

  const erreurs = ref({ });

  const {loadRecaptcha, executeRecaptcha} = useRecaptcha('6LcWWiwrAAAAAAX71p6me0HWoPzX0zTxNaw_R9ml');

  function onSubmit(e) {
    e.preventDefault();
    console.log("onSubmit appelé");
    console.log('Validation:', validateFormMessage(form.value, erreurs.value));
    console.log('Erreurs:', erreurs.value);


  if (validateFormMessage(form.value, erreurs.value)) {
    loadRecaptcha()
      .then(() => executeRecaptcha('submit'))
      .then(token => {
        const formData = new FormData(document.getElementById('form'));
        console.log('Token généré :', token);
        formData.append('g-recaptcha-response', token);

        fetch('/backend/submit_message.php', {

          method: 'POST',
          body: formData,
        })
          .then(async res => {
            const text = await res.text();
            console.log("Réponse brute du backend :", text);
            try {
              return JSON.parse(text);
            } catch (e) {
              console.error("Erreur parsing JSON :", e);
              throw e; // rejette pour catch global
            }
          })

          .then(data => {
            if (data.success) {
              router.push('/confirmation-message');
            } else {
              console.error(data.message || "Erreur lors de l'envoi");
            }
          })
          .catch(err => {
            console.error("Échec de l'exécution de reCAPTCHA", err);
          });
      })
      .catch(() => {
        console.error("Échec de l'exécution de reCAPTCHA.");
      });
  } else {
    console.log("Validation échouée", erreurs.value);
  }
}
</script>
